module.exports = __webpack_public_path__ + "media/directory/topic_icon_hover-0520ce04.svg";